import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loading: false,
  filterLoader: false,
  questionsLoader: false,
  chartLoader: false,
  questionnaireNames: [],
  clientNames: [],
  filtersData: [],
  surveyQues: [],
  surveyQuesCrosstab: [],
  questionsData: [],
  chartData: {},
  years: [],
  errorMsg: '',
  isFetch: false,
  searchLoading: false,
  searchData: [],
  excelData: []
};

const reportSlice = createSlice({
  name: 'reports',
  initialState: INITIAL_STATE,
  reducers: {
    getQuestionaireList(state) {
      state.loading = true;
      state.isFetch = false;
    },
    getClientList(state) {
      state.loading = true;
      state.isFetch = false;
    },
    stopLoading(state) {
      state.loading = false;
    },
    setQuestionnaireNames(state, { payload }) {
      state.loading = false;
      state.isFetch = true;
      state.questionnaireNames = payload;
    },
    setClientNames(state, { payload }) {
      state.loading = false;
      state.isFetch = true;
      state.clientNames = payload;
    },
    setSurveyQues(state, { payload }) {
      state.isFetch = true;
      state.surveyQues = payload;
    },
    setSurveyQuesCrosstab(state, { payload }) {
      state.isFetch = true;
      state.surveyQuesCrosstab = payload;
    },
    getFilter(state) {
      state.filterLoader = true;
    },
    stopLoadingFilter(state) {
      state.filterLoader = false;
    },
    setFilterData(state, { payload }) {
      state.filterLoader = false;
      state.filtersData = payload;
    },
    getChartData(state) {
      state.chartLoader = true;
    },
    stopChartLoader(state) {
      state.chartLoader = false;
    },
    setChartData(state, { payload }) {
      state.chartLoader = false;
      state.chartData = payload.chartData ? payload.chartData : payload.chartDataCrossTab;
    },
    setYears(state, { payload }) {
      state.loading = false;
      state.years = payload;
    },
    searchLoading(state, { payload }) {
      state.searchLoading = payload;
    },
    setSearchData(state, { payload }) {
      state.searchLoading = false;
      state.searchData = payload;
    },
    setExcelData(state, { payload }) {
      state.loading = false;
      state.excelData = payload;
    },
    resetallData(state) {
      state.questionnaireNames = [];
      state.filtersData = [];
      state.surveyQues = [];
      state.surveyQuesCrosstab = [];
      state.questionsData = [];
      state.chartData = [];
      state.years = [];
      state.searchData = [];
      state.excelData = [];
    }
  }
});

export const reportAction = reportSlice.actions;

export default reportSlice.reducer;
